import { render } from "./UangMasuk.vue?vue&type=template&id=a434a692"
import script from "./UangMasuk.vue?vue&type=script&lang=js"
export * from "./UangMasuk.vue?vue&type=script&lang=js"
script.render = render

export default script